import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { Container } from '../Container';
import { BoxFullSectionListContentType } from '../contentTypes';
import { Section } from '../Section';

export interface BoxFullSectionListProps {
  boxFullSectionList?: BoxFullSectionListContentType;
}

export const BoxFullSectionList = ({ boxFullSectionList }: BoxFullSectionListProps) => {
  const currentBreakpoint = b2x.useBreakpoint();

  return (
    <Section className="box-full-section">
      {boxFullSectionList?.map((boxFullSection) => (
        <div className="position-relative" key={boxFullSection.contentSectionId}>
          <b2x.ImageFromContentV1 {...boxFullSection.img} className="w-100" fluid />
          {(boxFullSection.copy || boxFullSection.cta) && (
            <div
              className={classnames(
                'message py-4 py-md-5 py-lg-0',
                !b2x.untilBreakpoint('md', currentBreakpoint) && boxFullSection.copy?.desktopColor === 'white'
                  ? 'text-white'
                  : 'text-black',
                b2x.untilBreakpoint('md', currentBreakpoint) && boxFullSection.copy?.mobileColor === 'white'
                  ? 'bg-black text-white'
                  : 'text-black',
              )}
            >
              <Container>
                <b2x.Row
                  className={classnames(
                    { 'justify-content-start': boxFullSection.copy?.alignment === 'left' },
                    { 'justify-content-center': boxFullSection.copy?.alignment === 'center' },
                    { 'justify-content-end': boxFullSection.copy?.alignment === 'right' },
                  )}
                >
                  <b2x.Col size={{ lg: 5, xs: 12 }}>
                    {boxFullSection.copy?.title && (
                      <h3
                        className={classnames(
                          'fw-bold',
                          { 'h1 mb-4': !b2x.untilBreakpoint('lg', currentBreakpoint) },
                          { 'h3 mb-2': b2x.untilBreakpoint('lg', currentBreakpoint) },
                        )}
                      >
                        {b2x.formatHtml(boxFullSection.copy.title)}
                      </h3>
                    )}
                    {boxFullSection.copy?.description && (
                      <div
                        className={classnames(
                          { 'h2 mb-4': !b2x.untilBreakpoint('lg', currentBreakpoint) },
                          { 'mb-3': b2x.untilBreakpoint('lg', currentBreakpoint) },
                        )}
                      >
                        {b2x.formatHtml(boxFullSection.copy.description)}
                      </div>
                    )}
                    {boxFullSection.cta?.label && (
                      <b2x.CtaFromContent
                        ctaProps={{
                          button: {
                            className: classnames(
                              'fw-medium text-uppercase',
                              !b2x.untilBreakpoint('md', currentBreakpoint) &&
                                boxFullSection.copy?.desktopColor === 'white'
                                ? 'btn-outline-white'
                                : 'btn-outline-secondary',
                              b2x.untilBreakpoint('md', currentBreakpoint) &&
                                boxFullSection.copy?.mobileColor === 'white'
                                ? 'btn-outline-white'
                                : 'btn-outline-secondary',
                            ),
                          },
                        }}
                        {...boxFullSection.cta}
                      />
                    )}
                  </b2x.Col>
                </b2x.Row>
              </Container>
            </div>
          )}
        </div>
      ))}
    </Section>
  );
};
